<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form v-if="SearchFlag" :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="用户id">
              <el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输入用户id" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" @click="search()">查询</el-button>
              <el-button @click="reset()">重置</el-button>
            </div>
          </el-col>

        </el-row>
      </el-form>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border>

        <el-table-column type="selection" width="55">
        </el-table-column>

        <el-table-column prop="name" label="头像" width="80">
          <template slot-scope="scope">
            <el-avatar shape="square" :size="50" :src="scope.row.avatar"></el-avatar>
          </template>
        </el-table-column>

        <el-table-column label="ID" width="50">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="昵称" width="120">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>

        <el-table-column prop="name" label="充值状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.is_pay == 1"><span style="color: #67C23A;size: 50px;">•</span>已支付</span>
            <span v-else-if="scope.row.is_pay == 0"><span style="color: red;size: 52px;">•</span>未支付</span>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="VIP状态">
          <template slot-scope="scope">
            <span v-if="scope.row.vip == 1">已开通</span>
            <span v-else-if="scope.row.vip == 0">未开通</span>
            <span v-else-if="scope.row.vip == 2">已过期</span>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="VIP结束时间" width="170">
          <template slot-scope="scope">{{ scope.row.vip_expired_at }}</template>
        </el-table-column>

        <el-table-column prop="name" label="性别">
          <template slot-scope="scope">
            <span v-if="scope.row.sex == 1">男</span>
            <span v-else-if="scope.row.sex == 2">女</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="永久积分" width="100">
          <template slot-scope="scope">{{ scope.row.balance }}</template>
        </el-table-column>

        <el-table-column prop="name" label="状态">
          <template slot-scope="scope"><el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>封禁</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="注册时间" width="170">
          <template slot-scope="scope">{{ scope.row.created_at }}</template>
        </el-table-column>

        <el-table-column prop="name" label="渠道号">
          <template slot-scope="scope">{{ scope.row.channel_code }}</template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="jumpToDetails(scope.row.id)">查看详情</el-button>
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList()" />

      <userEdit v-if="dialogVisible" :dialogVisible="dialogVisible" @NoneDlog="NoneDlog" @AddOk="AddOk"
                       :editID="editID" :userInfo="userInfo"></userEdit>

    </el-card>
  </div>
</template>

<script>
import {userApi} from "@/api/user";
import userEdit from "./userEdit.vue"
import { processErrors } from "@/utils/errorHandler";

export default {
  components: {
    userEdit
  },
  data() {
    return {
      form: {
        name: ""
      },
      SearchFlag: true,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        id: "",
      },
      tableData: [],
      multipleSelection: [],
      // 总条数
      total: 0,
      dialogVisible: false,
      editID:'',
      userInfo:{},
    };
  },
  created() {
  },
  methods: {
    getList() {
      let api = userApi();
      this.tableData = [];
      api.getUserList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        }else{
          processErrors(res);
        }
      }).catch(error => {
        console.error('Error fetching user data:', error);
        this.loading = false;
      });
    },

    search() {
      this.getList();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    reset(){
      this.queryParams = {}
    },

    NoneDlog() {
      this.dialogVisible = false
    },
    AddOk() {
      this.dialogVisible = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id
      this.userInfo = row
      this.dialogVisible = true
    },

    jumpToDetails(id){
      this.$router.push({
        path: '/user/userList/info',
        query: {
          id: id
        },
      })
    }
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>